import {Component, store} from 'Generic';
import {getCurrentPrice, numberFormat, addCurrencySymbol, calculateTotalOldPrice} from 'Generic/lib';

export default class PlanBoxes extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.cart-boxes-wrapper'),
      state: store.state,
    });
  }

  render() {
    const instance = this;
    const mainCartBox = document.querySelectorAll('.pro-cart-container .plan-box-wrapper');
    const grp_by_billing_cycle = [];
    const selectedCurrency = cartState.currency_code;

    let planCount = 0;

    for (let plan in cartState.plans) {
      const billingCycle = cartState.plans[plan].billing_cycle.toLowerCase();
      if (!grp_by_billing_cycle[billingCycle]) {
        grp_by_billing_cycle[billingCycle] = [];
      }
      grp_by_billing_cycle[billingCycle].push(cartState.plans[plan]);
    }

    let count = 0;

    for (let grp in grp_by_billing_cycle) {
      const dataBillingCycle = mainCartBox[count].getAttribute('data-billing-cycle');
      const plusCartBox = mainCartBox[count].querySelectorAll('.cart-box');

      plusCartBox.forEach(function (value, key) {
        const plan = grp_by_billing_cycle[dataBillingCycle][key];
        const selectedPlan = plan;

        const sumRequiredAddonPrice = calculateTotalOldPrice(1, cartState.old_prices, selectedCurrency, selectedPlan);
        const planPricePerMonth = selectedPlan?.per_month;

        // cut price placeholders
        const proCartCutPricee = value.querySelector('.pro-cart-box-month-div .pro-dt-ppl');
        if (proCartCutPricee) {
          proCartCutPricee.innerHTML = planPricePerMonth < sumRequiredAddonPrice ? `${addCurrencySymbol(numberFormat(sumRequiredAddonPrice))}` : '';
        }

        const moneyBackLabel = value.querySelector('.money-back-label');
        if (moneyBackLabel) {
          const planLabel = selectedPlan?.labels['money_back_label'] || plan?.labels['money_back_label'];
          moneyBackLabel.innerHTML = `${planLabel.replace(/\(price\)/g, instance.getCurrentPriceOnly(selectedPlan))}`;

          moneyBackLabel.innerHTML = moneyBackLabel.innerHTML.replace(/\(discounted-price\)/g, getCurrentPrice(selectedPlan));

          moneyBackLabel.innerHTML = moneyBackLabel.innerHTML.replace(
            /\(month-price\)/g,
            `${selectedPlan.per_month}${cartState.currencies_symbol[selectedCurrency]}`,
          );
        }

        const proCartBoxText = value.querySelector('.pro-cart-box-btm-text p');
        if (proCartBoxText) {
          const planLabel = selectedPlan?.labels['fpdr_text_label'] || plan?.labels['fpdr_text_label'];
          proCartBoxText.innerHTML = planLabel.replace(/\(price\)/g, instance.getCurrentPriceOnly(selectedPlan));

          proCartBoxText.innerHTML = proCartBoxText.innerHTML.replace(/\(discounted-price\)/g, getCurrentPrice(selectedPlan));

          proCartBoxText.innerHTML = proCartBoxText.innerHTML.replace(
            /\(month-price\)/g,
            `${selectedPlan?.per_month}${cartState.currencies_symbol[selectedCurrency]}`,
          );
        }

        planCount++;
      });

      count++;
    }
  }

  //get current price only
  getCurrentPriceOnly(plan) {
    return plan.unit_amount + cartState.currencies_symbol[cartState.currency_code];
  }
}
